export default __webpack_public_path__ + "static/media/manufacturing3.f0b67e9a.png";